import cookie from "react-cookies"


export const getCaseNamePlaceholder = () => (cookie.load("organisation_setting") || {})["case_collapse_menu_config"]?.["case_name_placeholder"] || "Folder"

export const getCaseIdPlaceholder = () => (cookie.load("organisation_setting") || {})["case_collapse_menu_config"]?.["case_id_placeholder"] || "Folder Name"